import { Component, Input,  } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { TransportCounts } from 'src/tmc-yard/common/model/transport.model';



@Component({
  selector: 'app-transport-counts',
  templateUrl: './transport-counts.component.html',
  styleUrls: ['./transport-counts.component.scss']
})
export class TransportCountsComponent  {

  @Input() counts: TransportCounts;

  constructor(public translationService: TranslationService) {}

}
